// eslint-disable-next-line @townsquare/rules/no-define-messages -- Legacy defineMessages usage; migrate under TC-48428
import { defineMessages } from 'react-intl';

export const rolePickerMessages = defineMessages({
	disableTooltipForRolePicker: {
		id: 'townsquare.invite-user-modal.role-picker.permission-tooltip',
		defaultMessage: 'No available roles to select. Please contact your Jira administrator.',
		description: 'Shown in a tooltip when the user tries to edit a locked-down permission setting.',
	},
	roleLabel: {
		id: 'townsquare.invite-user-modal.role-picker.role-label',
		defaultMessage: 'Select a Jira space role',
		description:
			'The label for a dropdown component which allows the user to select the role the invited person will have.',
	},
	errorFetchRolesMessage: {
		id: 'townsquare.invite-user-modal.role-picker.error-fetch-roles-message',
		defaultMessage: 'Unable to fetch roles. Please try again.',
		description: 'Error message shown when roles could not be fetched.',
	},
	noRolesMessage: {
		id: 'townsquare.invite-user-modal.role-picker.no-roles-message',
		defaultMessage: 'Unable to get available roles for this space. Please try again.',
		description:
			'Error message shown when no roles are available for selection in the role picker.',
	},
});
